import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const secretsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/secrets',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: { label: 'Secrets', isCurrentPage: true },
        },
    ],
};
